import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-request-form-popup',
  templateUrl: './request-form-popup.component.html',
  styleUrls: ['./request-form-popup.component.scss'],
})
export class RequestFormPopupComponent {
  constructor(public dialogRef: MatDialogRef<RequestFormPopupComponent>) {}
  closeModal() {
    this.dialogRef.close();
  }
}
